import Vue from 'vue';
import Vuex from 'vuex';
import alerts from './modules/alerts';
import auth from './modules/auth';
import avatar from './modules/avatar';
import config from './modules/config';
import containers from './modules/containers';
import dialog from './modules/dialog';
import integrations from './modules/integrations';
import lines from './modules/lines';
import locations from './modules/locations';
import mentions from './modules/mentions';
import notifications from './modules/notifications';
import reservations from './modules/reservations';
import chats from './modules/chats';
import stripe from './modules/stripe';
import turns from './modules/turns';
import workspace from './modules/workspace';
import bookings from './modules/bookings';
import settings from './modules/settings';
import agency from './modules/agency';
import onboardingDocuments from './modules/onboardingDocuments';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    alerts,
    auth,
    avatar,
    config,
    containers,
    dialog,
    integrations,
    lines,
    locations,
    mentions,
    notifications,
    reservations,
    stripe,
    turns,
    workspace,
    chats,
    bookings,
    settings,
    agency,
    onboardingDocuments,
  },
});
